import { render, staticRenderFns } from "./TheMenuControls.vue?vue&type=template&id=45a29ba7&scoped=true&"
import script from "./TheMenuControls.vue?vue&type=script&lang=js&"
export * from "./TheMenuControls.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuControls.vue?vue&type=style&index=0&id=45a29ba7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a29ba7",
  null
  
)

export default component.exports